import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ToastService, ToastType } from '../../core/services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  template: `
  <div class="pointer-events-none fixed right-4 top-4 z-[9999] flex w-[calc(100vw-2rem)] max-w-md flex-col gap-3 sm:right-6 sm:top-6">
    <div
      *ngFor="let toast of toast.items$ | async"
      class="pointer-events-auto overflow-hidden rounded-3xl border bg-white/95 p-4 shadow-2xl shadow-slate-950/10 backdrop-blur-xl transition"
      [ngClass]="cardClass(toast.type)">
      <div class="flex items-start gap-3">
        <div class="grid h-10 w-10 shrink-0 place-content-center rounded-2xl text-lg" [ngClass]="iconClass(toast.type)">
          {{ icon(toast.type) }}
        </div>
        <div class="min-w-0 flex-1">
          <p class="text-sm font-black text-slate-950">{{ toast.title }}</p>
          <p *ngIf="toast.message" class="mt-1 text-sm leading-5 text-slate-600">{{ toast.message }}</p>
        </div>
        <button
          type="button"
          class="grid h-8 w-8 shrink-0 place-content-center rounded-full text-slate-400 transition hover:bg-slate-100 hover:text-slate-950"
          (click)="toastService.remove(toast.id)">
          ×
        </button>
      </div>
      <div class="mt-3 h-1 overflow-hidden rounded-full bg-slate-100">
        <div class="h-full rounded-full" [ngClass]="barClass(toast.type)"></div>
      </div>
    </div>
  </div>
  `,
  styles: [`
    @keyframes toastBar { from { width: 100%; } to { width: 0%; } }
    .h-full { animation: toastBar 4s linear forwards; }
  `]
})
export class ToastContainerComponent {
  constructor(public toast: ToastService) {}

  get toastService(): ToastService {
    return this.toast;
  }

  icon(type: ToastType): string {
    return {
      success: '✅',
      error: '⚠️',
      info: 'ℹ️',
      warning: '🔔',
    }[type];
  }

  cardClass(type: ToastType): string {
    return {
      success: 'border-emerald-200',
      error: 'border-rose-200',
      info: 'border-sky-200',
      warning: 'border-amber-200',
    }[type];
  }

  iconClass(type: ToastType): string {
    return {
      success: 'bg-emerald-50 text-emerald-700',
      error: 'bg-rose-50 text-rose-700',
      info: 'bg-sky-50 text-sky-700',
      warning: 'bg-amber-50 text-amber-700',
    }[type];
  }

  barClass(type: ToastType): string {
    return {
      success: 'bg-emerald-500',
      error: 'bg-rose-500',
      info: 'bg-sky-500',
      warning: 'bg-amber-500',
    }[type];
  }
}
